// extracted by mini-css-extract-plugin
export default {"controlsContainer":"Controls__controlsContainer--2O6"};